module.exports = __webpack_public_path__ + "img/part6-icon1.e52b9ee5.png";